import { render, staticRenderFns } from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=template&id=f8771572&scoped=true"
import script from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=script&lang=js"
export * from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=script&lang=js"
import style0 from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=style&index=0&id=f8771572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8771572",
  null
  
)

export default component.exports